<template>
    <div class="main-bd mg20 pro-visible">
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcheModel" class="external-form">
                <el-form-item label="目标年份">
                    <el-date-picker
                        v-model="searcheModel.year"
                        type="year"
                        format="yyyy"
                        value-format="yyyy"
                        placeholder="选择年">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="所属部门">
                    <UserCascader
                    v-model="searcheModel.branch_id"
                    ref="branch"
                    :isBusiness="true"
                    @change="changeBranch"
                    ></UserCascader>
                </el-form-item>
                <el-form-item label="业务员">
                    <UserSelect ref="user" @change="changeUser"></UserSelect>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                    <ExportFile 
                    v-if="Acs('/sale-analysis/goal-finish')"
                    :url="'/api/export/' + activeName" 
                    :params="searcheModel" 
                    :filename="searcheModel.count_type == 1 ? '目标完成情况-回款业绩(部门)' : '目标完成情况-回款业绩(成员)'" 
                    buttonName="导出Excel">
                    </ExportFile>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row class="searchSection">
            <el-col :span="22">
                <el-tabs type="card" v-model="searcheModel.count_type" @tab-click="submitSearch">
                    <el-tab-pane label="按部门" name="1"></el-tab-pane>
                    <el-tab-pane label="按成员" name="2"></el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col :span="2">
                <CountConfig v-if="Acs('/count-config/view')" :path="$route.path" :tab="searcheModel.tab"></CountConfig>
            </el-col>
        </el-row>
        <h5 style="color:#85CE61;">协作单已按照业务员个人业绩占比拆分</h5>
        <el-row class="searchSection">
            <el-radio-group v-model="searcheModel.count_mode" @input="submitSearch">
                <el-radio label="1">当月目标及完成</el-radio>
                <el-radio label="2">累计目标及完成</el-radio>
            </el-radio-group>
        </el-row>
        <div v-loading="loading">
            <el-table 
            v-if="!loading"
            :data="list" 
            border 
            height="650"
            row-key="id" 
            :tree-props="{children: 'children'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="1"
            >
                <template v-if="searcheModel.count_type == 1">
                    <el-table-column prop="name" label="月份丨部门丨业务员" width="220"></el-table-column>
                </template>
                <template v-else>
                    <el-table-column prop="name" label="月份丨业务员"></el-table-column>
                    <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                </template>
                <el-table-column prop="pfm_goal" label="目标金额"></el-table-column>
                <el-table-column prop="pfm_finish_amount" width="150">
                    <template slot="header">
                        <!-- 自定义表头 -->
                        <span>完成金额</span>
                        <el-tooltip class="item" effect="dark" content="包括本月录单正式(新单)和正式(续单)这两种订单里的新增业绩" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.pfm_finish_amount }}
                    </template>
                </el-table-column>
                <el-table-column prop="pfm_finish_ratio" label="完成率">
                    <template slot-scope="scope">
                        {{ scope.row.pfm_finish_ratio ? scope.row.pfm_finish_ratio + '%' : ''}}
                    </template>
                </el-table-column>
                <el-table-column prop="last_pfm_finish_amount" label="完成金额同比"></el-table-column>
                <el-table-column prop="pfm_yoy_raise" label="完成增长率">
                    <template slot-scope="scope">
                        {{ scope.row.pfm_yoy_raise ? scope.row.pfm_yoy_raise + '%' : ''}}
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
  </template>
  <style scoped>
  </style>
  <script>
  import SaleanalysisCount from "~/services/saleanalysisCount";
  import UserCascader from "~/widgets/UserCascader.vue";
  import UserSelect from "~/widgets/UserSelect.vue";
  import Config from "~/config/params";
  import ExportFile from "~/widgets/ExportFile.vue";
  import CountConfig from "~/widgets/CountConfig.vue";
  export default {
    components: {
        UserCascader,
        UserSelect,
        Config,
        ExportFile,
        CountConfig
    },
  
    props: {
        activeName: {
            type: String,
            default: ''
        }
    },
  
    data() {
        return {
            loading: false,
            list: [],
            searcheModel: {},
        };
    },
  
    mounted() {
        
    },
  
    created() {
        this.resetForm();
    },
  
    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {
                branch_id: "",
                user_id: "",
                count_type: '1',
                year: new Date().getFullYear().toString(),
                created_at: [],
                target_at: [],
                path: this.$route.path,
                tab: 'goal-manage-actual',//这里调用目标管理的配置信息
                finance_audit: '',
                count_mode: '1',
            };
            if(this.$refs['user']){
                this.$refs['user'].reset();
            }
            if(this.$refs['branch']){
                this.$refs['branch'].reset();
            }
            this.list = [];
            this.submitSearch();
        },
    
        // 筛选查询
        submitSearch() {
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },
    
        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            SaleanalysisCount.getList(params, this.activeName).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        //切换业务员子组件
        changeUser(object) {
            this.searcheModel.user_id = object.label;
        },

        //切换部门子组件
        changeBranch(value) {
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel.branch_id = value[value.length - 1];
            } else {
                this.searcheModel.branch_id = "";
            }
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // 第一列不计算合计，显示自定义的文字内容
                if (index === 0) {
                    sums.push('合计：' + data.length + '条');
                    return;
                }
                // 初始化合计值为0
                let sum = 0;
                // 遍历数据，累加顶级行的值
                data.forEach(item => {
                    // 累加当前项的值，注意转换为数字
                    sum += Number(item[column.property]);
                });
                // 如果所有值都是数字，则显示合计结果，否则显示'-'
                if (!isNaN(sum)) {
                    sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                } else {
                    sums.push(0);
                }
            });
            sums[3] = sums[1] > 0 ? Math.round(sums[2] / sums[1] * 10000) / 100 + '%' : '';
            sums[5] = sums[4] > 0 ? Math.round((sums[2] - sums[4]) / sums[4] * 10000) / 100 + '%' : '';
            return sums;
        },

        // 查看
        handleView(row) {
            let query = _.clone(this.searcheModel);
            if(row.hasOwnProperty('user_id')){
                query['user_id'] = row.user_id;
            }else{
                query['branch_id'] = row.branch_id;
            }
            query['activeName'] = 'payment-detail';
            query['months'] = [query.year + '-' + row.month, query.year + '-' + row.month];
            let routeData = this.$router.resolve({
                path: "/count/payment",
                query: query,
            });
            window.open(routeData.href, '_blank');
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/count/table/goalFinishActual.vue